//app
import { ModelBase } from "@shoothill/core";
import { formatDate } from "Application";
import { makeObservable, observable } from "mobx";

export class MentorModel extends ModelBase<MentorModel> {
    // #region Model Properties
    public firstName: string | null = null;
    public lastName: string | null = null;
    public email: string | null = null;
    public phone: string | null = null;
    public lastActionFirstName: string | null = null;
    public lastActionLastName: string | null = null;
    public lastActionDate: Date | null = null;
    public lastActionByUserId: string | null = null;

    constructor() {
        super();
        makeObservable(this, {});
    }
    // #region Formatted Properties

    public get formattedFullName() {
        return `${this.firstName} ${this.lastName}`;
    }

    public get formattedActionName() {
        return `${this.lastActionFirstName} ${this.lastActionLastName}`;
    }

    public get actionDate() {
        return !!this.updatedDate ? this.updatedDate : this.lastActionDate;
    }

    public get lastActionDates() {
        return this.lastActionDate;
    }

    public get phones() {
        return this.phone;
    }

    public get formattedLastActionDate() {
        return formatDate(this.lastActionDate);
    }
}
